export default __webpack_public_path__ + "static/media/dfv-thumbnail.5f8be5ff.png";